// eslint-disable-next-line no-unused-vars
import React, { useEffect }  from "react";
import { connect } from "react-redux";

import styles from "./SessionExpirationModal.module.scss";

import Modal from "components/Modal/Modal";
import Button from "components/Button/Button";
import { hideSessionModalAction, loadSitesAction, loadUserSettingsFormAction, authLogoutAction } from "store/actions/Actions";

const SessionExpirationModal = props => {
    const [counter, setCounter] = React.useState(0);
    const { message, isLoggedIn } = props;
    useEffect(() => {
        counter > 0 && message && window.setTimeout(() => setCounter(counter - 1), 1000);
        if (message && counter == 0){
            props.hideSessionModalAction();
            props.authLogoutAction();
        }
    }, [counter]);

    useEffect(() => {
        if (message && isLoggedIn){
            if (document.fullscreenElement) {
                document.exitFullscreen();
            }
            setCounter(60);
        }
    }, [message, isLoggedIn]);

    return (
        message && isLoggedIn ?
            <Modal
                className={styles.modal}
                setShowModal={props.setShowModal}
                
                disableCloseButton={true} 
            >
                <div>
                    <p className={styles["modal-heading"]}>Session will expire</p>
                    <div className={styles["modal-content"]}>
                        Your session will expire in {counter} seconds. To continue using the application click continue session button.
                    </div>

                    <div className={styles["modal-footer"]}>
                        <Button
                            text="CONTINUE SESSION"
                            color="primary"
                            onClick={() => { props.loadUserSettingsFormAction(); props.hideSessionModalAction(); }}
                        />
                    </div>
                </div>
            </Modal>
        : ''
    );
       
};

const mapStateToProps = (state) => ({
    message: state.SessionModalReducer.message,
    isLoggedIn: state.AuthReducer.isLoggedIn,
});

const mapDispatchToProps = {
    loadUserSettingsFormAction,
    hideSessionModalAction,
    loadSitesAction,
    authLogoutAction
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SessionExpirationModal);
